import { pick } from 'lodash'

const brandCurationTaskTagsFormInitialValues = values =>
  pick(values, ['tags', 'problemReason', 'problemComment'])

export default brandCurationTaskTagsFormInitialValues
